var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#twitter_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.479 6.964c.015.21.015.42.015.632 0 6.457-4.917 13.905-13.906 13.905v-.004a13.835 13.835 0 0 1-7.491-2.19 9.814 9.814 0 0 0 7.233-2.025 4.893 4.893 0 0 1-4.566-3.395 4.872 4.872 0 0 0 2.206-.084 4.888 4.888 0 0 1-3.92-4.79V8.95c.68.379 1.44.589 2.218.612a4.893 4.893 0 0 1-1.513-6.525 13.871 13.871 0 0 0 10.073 5.105 4.892 4.892 0 0 1 8.328-4.457 9.807 9.807 0 0 0 3.104-1.186A4.906 4.906 0 0 1 21.11 5.2a9.719 9.719 0 0 0 2.807-.769 9.927 9.927 0 0 1-2.44 2.532z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "twitter_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 2)",
  d: "M0 0h24v19.742H0z"
})))));
export default SvgTwitter;